// MODÜL 11: TÜRK HAVAYOLLARI ŞİRKETLERİ

const cabinCrewContentsM11 = {
  // ==================== THY ====================
  'CM-M11-U1-L1': {
    lesson_id: 'CM-M11-U1-L1',
    title: 'THY Tarihi ve Vizyonu',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Türk Hava Yolları - Tarihçe',
      paragraphs: [
        'Türk Hava Yolları (THY), 1933 yılında kurulmuş, Türkiye\'nin bayrak taşıyıcı havayolu şirketidir.',
        'Kuruluş: 20 Mayıs 1933\'te "Devlet Hava Yolları" adıyla 5 uçakla başladı. 1956\'da "Türk Hava Yolları" adını aldı.',
        'Slogan: "Widen Your World" - Dünyanızı Genişletin. Bu slogan THY\'nin geniş uçuş ağını vurgular.',
        'Star Alliance: 2008\'de dünyanın en büyük havayolu ittifakı Star Alliance\'a katıldı.',
        'Vizyon: "En çok tercih edilen havayolu olmak" - THY müşteri memnuniyetini ön planda tutar.'
      ],
      keyPoints: [
        'Kuruluş: 1933',
        'Star Alliance üyesi (2008)',
        'Hub: İstanbul Havalimanı (IST)',
        'Slogan: Widen Your World'
      ]
    }
  },
  'CM-M11-U1-L2': {
    lesson_id: 'CM-M11-U1-L2',
    title: 'THY Filo Yapısı',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'THY Filosu',
      paragraphs: [
        'THY, 400+ uçaklık filosuyla Avrupa\'nın en büyük filolarından birine sahiptir.',
        'Dar Gövde: Airbus A321neo, A320, A319 - Kısa ve orta mesafe uçuşlar için.',
        'Geniş Gövde: Boeing 787 Dreamliner, 777-300ER, Airbus A350 - Uzun mesafe uçuşlar için.',
        'Kargo: Turkish Cargo, Avrupa\'nın 1 numaralı, dünyanın 5. büyük kargo taşıyıcısı.',
        'Yeni Nesil: THY filosunu sürekli yeniliyor. 787 ve A350 en yeni uçaklar arasında.'
      ],
      keyPoints: [
        '400+ uçak',
        'Airbus A321neo, A350',
        'Boeing 787, 777-300ER',
        'Turkish Cargo - Avrupa 1.'
      ]
    }
  },
  'CM-M11-U1-L3': {
    lesson_id: 'CM-M11-U1-L3',
    title: 'THY Hub ve Destinasyonlar',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'THY Uçuş Ağı',
      paragraphs: [
        'İstanbul Havalimanı (IST): THY\'nin ana hub\'ı. 2019\'da açıldı, dünyanın en büyük havalimanlarından.',
        'Destinasyon Sayısı: 340+ destinasyon, 130+ ülke - En fazla ülkeye uçan havayolu!',
        'Coğrafi Avantaj: İstanbul\'un konumu sayesinde 3 saat içinde 60+ ülkeye ulaşılabiliyor.',
        'Afrika Lideri: THY, Afrika\'ya en çok uçan yabancı havayolu. 60+ Afrika destinasyonu var.',
        'Yurtiçi: Sabiha Gökçen (SAW), Ankara Esenboğa (ESB) dahil 50+ iç hat noktası.'
      ],
      keyPoints: [
        'Ana Hub: İstanbul (IST)',
        '340+ destinasyon',
        '130+ ülke',
        'Afrika lideri'
      ]
    }
  },
  'CM-M11-U1-L4': {
    lesson_id: 'CM-M11-U1-L4',
    title: 'THY Kabin Ekibi Beklentileri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'THY Kabin Memuru Olmak',
      paragraphs: [
        'THY, Türkiye\'nin en prestijli kabin memuru işverenlerinden. Yılda binlerce başvuru alır.',
        'Dil: İngilizce ZORUNLU. İkinci yabancı dil (Almanca, Fransızca, Arapça vb.) avantaj.',
        'Fiziksel: Boy/kilo oranı, sağlık kontrolü, yüzme becerisi önemli.',
        'Eğitim: En az lise mezunu. Üniversite mezunları tercih edilir.',
        'Süreç: Online başvuru → CV eleme → Grup mülakatı → Birebir mülakat → Sağlık → Eğitim.'
      ],
      keyPoints: [
        'İngilizce zorunlu',
        '2. dil avantaj',
        'Min. lise mezunu',
        '6 aşamalı süreç'
      ]
    }
  },
  'CM-M11-U1-L5': {
    lesson_id: 'CM-M11-U1-L5',
    title: 'THY Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'THY hangi yıl kuruldu?', options: ['1923', '1933', '1956', '2008'], correct: 1 },
        { q: 'THY hangi havayolu ittifakına üye?', options: ['Oneworld', 'SkyTeam', 'Star Alliance', 'Hiçbiri'], correct: 2 },
        { q: 'THY\'nin ana hub\'ı neresi?', options: ['Ankara', 'Sabiha Gökçen', 'İstanbul Havalimanı', 'Antalya'], correct: 2 },
        { q: 'THY kaç destinasyona uçar?', options: ['100+', '200+', '340+', '500+'], correct: 2 },
        { q: 'THY sloganı nedir?', options: ['Fly Emirates', 'Widen Your World', 'The World\'s Airline', 'Fly High'], correct: 1 }
      ]
    }
  },

  // ==================== PEGASUS ====================
  'CM-M11-U2-L1': {
    lesson_id: 'CM-M11-U2-L1',
    title: 'Pegasus Tarihi',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Pegasus Airlines - Tarihçe',
      paragraphs: [
        'Pegasus, 1990 yılında charter şirketi olarak kuruldu. 2005\'te tarifeli seferlere başladı.',
        'Dönüşüm: 2005\'te Esas Holding\'e satıldı ve düşük maliyetli (LCC) model benimsendi.',
        'Büyüme: Türkiye\'nin en hızlı büyüyen havayolu. İç ve dış hat ağını sürekli genişletiyor.',
        'Slogan: "Herkes Uçabilir" - Low-cost felsefesini yansıtıyor.',
        'Borsa: 2013\'te Borsa İstanbul\'da işlem görmeye başladı.'
      ],
      keyPoints: [
        'Kuruluş: 1990',
        'LCC modeli: 2005',
        'Hub: Sabiha Gökçen (SAW)',
        'Slogan: Herkes Uçabilir'
      ]
    }
  },
  'CM-M11-U2-L2': {
    lesson_id: 'CM-M11-U2-L2',
    title: 'Pegasus İş Modeli',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Pegasus LCC Modeli',
      paragraphs: [
        'LCC (Low-Cost Carrier): Düşük maliyetli havayolu. Temel bilet + ücretli ekstralar.',
        'Bagaj: El bagajı ücretsiz, kayıtlı bagaj ücretli. "Essentials" ve "Advantage" paketleri var.',
        'Koltuk: Standart koltuk seçimi ücretsiz değil. Extra legroom ayrıca ücretli.',
        'Yemek: Uçuşta yiyecek/içecek satın alınır. Ücretli ikram servisi.',
        'Fiyat: Temel bilet fiyatları THY\'den düşük ama ekstra hizmetler ayrı ücret.'
      ],
      keyPoints: [
        'Düşük maliyetli model',
        'Ücretli bagaj sistemi',
        'Ücretli koltuk seçimi',
        'Satın alınır ikram'
      ]
    }
  },
  'CM-M11-U2-L3': {
    lesson_id: 'CM-M11-U2-L3',
    title: 'Pegasus Filo ve Rotalar',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Pegasus Operasyonu',
      paragraphs: [
        'Filo: 100+ uçak. Airbus A320neo ve A321neo ağırlıklı. Boeing 737 MAX da filoda.',
        'Ana Hub: Sabiha Gökçen Havalimanı (SAW) - İstanbul\'un Anadolu yakası.',
        'İkincil Hub: Ankara Esenboğa (ESB), İzmir Adnan Menderes (ADB).',
        'Destinasyonlar: 120+ destinasyon, 45+ ülke. Avrupa, Ortadoğu, Orta Asya ağırlıklı.',
        'Yurtiçi: Türkiye\'nin tüm önemli şehirlerine uçuş. Rekabetçi fiyatlar.'
      ],
      keyPoints: [
        '100+ uçak',
        'A320neo ailesi',
        'Hub: SAW',
        '120+ destinasyon'
      ]
    }
  },
  'CM-M11-U2-L4': {
    lesson_id: 'CM-M11-U2-L4',
    title: 'Pegasus Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Pegasus hangi yıl LCC modeline geçti?', options: ['1990', '2000', '2005', '2010'], correct: 2 },
        { q: 'Pegasus ana hub\'ı neresi?', options: ['İstanbul Havalimanı', 'Sabiha Gökçen', 'Ankara', 'Antalya'], correct: 1 },
        { q: 'Pegasus sloganı nedir?', options: ['Widen Your World', 'Herkes Uçabilir', 'Fly High', 'Connect'], correct: 1 },
        { q: 'Pegasus hangi uçak tipini kullanır?', options: ['Boeing 787', 'Airbus A380', 'Airbus A320neo', 'Embraer'], correct: 2 },
        { q: 'LCC ne demek?', options: ['Large Cargo Carrier', 'Low-Cost Carrier', 'Luxury Class Cabin', 'Local City Connector'], correct: 1 }
      ]
    }
  },

  // ==================== SUNEXPRESS ====================
  'CM-M11-U3-L1': {
    lesson_id: 'CM-M11-U3-L1',
    title: 'SunExpress Hikayesi',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'SunExpress - Tarihçe',
      paragraphs: [
        'SunExpress, 1989 yılında THY ve Lufthansa ortaklığıyla kuruldu. %50-%50 ortaklık.',
        'Amaç: Türkiye-Almanya arasındaki yoğun turist ve gurbetçi trafiğini karşılamak.',
        'Ana Üs: Antalya - Türkiye\'nin turizm başkenti. İkincil üs: İzmir.',
        'Hibrit Model: Ne tam LCC ne tam geleneksel. İkisinin karışımı bir model.',
        'Slogan: "We love to fly you" - Sizi uçurmayı seviyoruz.'
      ],
      keyPoints: [
        'Kuruluş: 1989',
        'THY + Lufthansa ortaklığı',
        'Ana üs: Antalya (AYT)',
        'Hibrit model'
      ]
    }
  },
  'CM-M11-U3-L2': {
    lesson_id: 'CM-M11-U3-L2',
    title: 'SunExpress Operasyonu',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'SunExpress Operasyonu',
      paragraphs: [
        'Filo: 90+ uçak. Boeing 737-800 ve 737 MAX 8 ağırlıklı.',
        'Rotalar: Türkiye\'den Avrupa\'ya (özellikle Almanya) ve iç hatlar.',
        'Sezonluk: Yaz aylarında turizm destinasyonlarına yoğun uçuş.',
        'Hizmet: Ücretsiz ikram (basit), bagaj dahil biletler mevcut.',
        'Almanya Odaklı: Düsseldorf, Frankfurt, München, Berlin hatları güçlü.'
      ],
      keyPoints: [
        '90+ uçak',
        'Boeing 737 ailesi',
        'Türkiye-Almanya odaklı',
        'Turizm sezonu yoğun'
      ]
    }
  },
  'CM-M11-U3-L3': {
    lesson_id: 'CM-M11-U3-L3',
    title: 'SunExpress Quiz',
    type: 'quiz',
    duration: 5,
    xp: 35,
    quiz: {
      questions: [
        { q: 'SunExpress\'in ortakları kim?', options: ['THY + Emirates', 'THY + Lufthansa', 'Pegasus + THY', 'BA + Lufthansa'], correct: 1 },
        { q: 'SunExpress ana üssü neresi?', options: ['İstanbul', 'İzmir', 'Antalya', 'Ankara'], correct: 2 },
        { q: 'SunExpress hangi yıl kuruldu?', options: ['1985', '1989', '1995', '2000'], correct: 1 },
        { q: 'SunExpress hangi uçak tipini kullanır?', options: ['Airbus A320', 'Boeing 737', 'Boeing 787', 'Embraer E190'], correct: 1 }
      ]
    }
  },

  // ==================== ANADOLUJET ====================
  'CM-M11-U4-L1': {
    lesson_id: 'CM-M11-U4-L1',
    title: 'AnadoluJet Hakkında',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'AnadoluJet - THY\'nin İç Hat Markası',
      paragraphs: [
        'AnadoluJet, THY\'nin düşük maliyetli iç hat markasıdır. 2008\'de kuruldu.',
        'Amaç: Anadolu şehirlerine uygun fiyatlı uçuş imkanı sunmak.',
        'Hub: Ankara Esenboğa (ESB) - İstanbul dışında merkez.',
        'Filo: THY filosundan Boeing 737-800 uçakları kullanır.',
        'Hizmet: THY standardında hizmet, uygun fiyatlar. İkram dahil.'
      ],
      keyPoints: [
        'THY markası',
        'Kuruluş: 2008',
        'Hub: Ankara (ESB)',
        'İç hat odaklı'
      ]
    }
  },
  'CM-M11-U4-L2': {
    lesson_id: 'CM-M11-U4-L2',
    title: 'AnadoluJet vs THY',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'AnadoluJet ve THY Karşılaştırması',
      paragraphs: [
        'AnadoluJet THY\'nin bir parçası ama farklı marka kimliği var.',
        'Fiyat: AnadoluJet genellikle THY\'den daha uygun.',
        'Hizmet: Aynı kabin ekibi, aynı güvenlik standartları.',
        'Rotalar: AnadoluJet iç hatlar + bazı dış hatlar. THY global.',
        'Miles & Smiles: Her iki markada da mil kazanılır.'
      ],
      keyPoints: [
        'Aynı şirket, farklı marka',
        'AnadoluJet daha uygun',
        'Aynı hizmet kalitesi',
        'Miles & Smiles geçerli'
      ]
    }
  },
  'CM-M11-U4-L3': {
    lesson_id: 'CM-M11-U4-L3',
    title: 'AnadoluJet Quiz',
    type: 'quiz',
    duration: 5,
    xp: 30,
    quiz: {
      questions: [
        { q: 'AnadoluJet hangi şirkete ait?', options: ['Pegasus', 'THY', 'SunExpress', 'Bağımsız'], correct: 1 },
        { q: 'AnadoluJet ana hub\'ı neresi?', options: ['İstanbul', 'Ankara', 'İzmir', 'Antalya'], correct: 1 },
        { q: 'AnadoluJet hangi yıl kuruldu?', options: ['2005', '2008', '2010', '2015'], correct: 1 }
      ]
    }
  },

  // ==================== MNG & DİĞERLERİ ====================
  'CM-M11-U5-L1': {
    lesson_id: 'CM-M11-U5-L1',
    title: 'MNG Airlines',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'MNG Airlines',
      paragraphs: [
        'MNG Airlines, Türk kargo havayolu şirketidir. MNG Holding bünyesinde.',
        'Kuruluş: 1996 yılında kuruldu. Önce yolcu, sonra kargo odaklı.',
        'Operasyon: Kargo charter uçuşları. Airbus A300 ve A330 kargo uçakları.',
        'Rotalar: Afrika, Avrupa, Asya kargo taşımacılığı.',
        'Not: MNG yolcu taşımacılığı yapmıyor, sadece kargo.'
      ],
      keyPoints: [
        'Kargo havayolu',
        'Kuruluş: 1996',
        'A300/A330 Cargo',
        'Yolcu taşımıyor'
      ]
    }
  },
  'CM-M11-U5-L2': {
    lesson_id: 'CM-M11-U5-L2',
    title: 'Corendon, Freebird, Tailwind',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Diğer Türk Havayolları',
      paragraphs: [
        'Corendon Airlines: Antalya merkezli. Turizm odaklı charter ve tarifeli uçuşlar. Boeing 737 filoya.',
        'Freebird Airlines: Charter havayolu. Tur operatörlerine hizmet. Antalya üslü.',
        'Tailwind Airlines: Küçük ölçekli Türk havayolu. Boeing 737 ile charter uçuşlar.',
        'Onur Air: 2013\'te kurulan, 2020\'de faaliyetlerini durduran havayolu.',
        'AtlasGlobal: 2001-2020 arası faaliyet gösterdi. İflas etti.'
      ],
      keyPoints: [
        'Corendon: Antalya, turizm',
        'Freebird: Charter',
        'Onur Air: Kapandı',
        'AtlasGlobal: İflas'
      ]
    }
  },
  'CM-M11-U5-L3': {
    lesson_id: 'CM-M11-U5-L3',
    title: 'Türk Havayolları Final',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Hangi havayolu kargo odaklı?', options: ['Pegasus', 'MNG Airlines', 'SunExpress', 'AnadoluJet'], correct: 1 },
        { q: 'Corendon hangi şehirde üslü?', options: ['İstanbul', 'İzmir', 'Antalya', 'Ankara'], correct: 2 },
        { q: 'SunExpress\'in ikinci ortağı?', options: ['Emirates', 'Lufthansa', 'BA', 'Air France'], correct: 1 },
        { q: 'AtlasGlobal\'ın durumu nedir?', options: ['Aktif', 'İflas', 'Satıldı', 'Birleşti'], correct: 1 },
        { q: 'AnadoluJet\'in ana hub\'ı?', options: ['İstanbul', 'Ankara', 'İzmir', 'Bursa'], correct: 1 }
      ]
    }
  },
};

export default cabinCrewContentsM11;
